// Core
import { call, put } from 'redux-saga/effects';

// Instruments
import { historyActions as actions } from 'bus/history/actions';
import { historyStorage as storage } from 'bus/history/storage';

export function* removeViewedHotelWorker ({ payload: hotelId }) {
    try {
        yield call([storage, 'remove'], hotelId);
        yield put(actions.removeViewedHotelSuccess());
    } catch (error) {
        yield put(actions.removeViewedHotelFail(error));
    }
}
